import React, { Component, Fragment } from 'react';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { getUsageStats } from '../../infrastructure/requests';

const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const styles = {};

class UsageBillingPeriod extends Component {
  state = {
      statsPeriodNow: undefined,
      statsPeriodBefore: undefined
  };
  componentDidMount = async () => {
      const dateNow = new Date();
      const firstDayNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
      const lastDayNow = new Date(
          dateNow.getFullYear(),
          dateNow.getMonth() + 1,
          0
      );
      const firstDayBefore = new Date(
          dateNow.getFullYear(),
          dateNow.getMonth() - 1,
          1
      );
      const lastDayBefore = new Date(
          dateNow.getFullYear(),
          dateNow.getMonth() - 1 + 1,
          0
      );
      const periodNow = await getUsageStats(firstDayNow, lastDayNow);
      const periodBefore = await getUsageStats(firstDayBefore, lastDayBefore);
      this.setState({
          statsPeriodNow: periodNow,
          statsPeriodBefore: periodBefore
      });
  };
  render() {
      const { statsPeriodNow, statsPeriodBefore } = this.state;
      return (
          <Fragment>
              <Grid container>
                  <Grid item>
                      <Grid container direction="column">
                          <Typography variant="h6" align="center">
                Current billing period
                          </Typography>
                          <div style={{ width: '100%', height: '2px' }} />
                          <Typography align="center">
                              {`${
                                  monthNames[new Date().getMonth()]
                              } ${new Date().getFullYear()} (until today)`}
                          </Typography>
                          <Tooltip
                              placement="right"
                              title={
                                  statsPeriodNow &&
                  `${statsPeriodNow.total_services} services + ${statsPeriodNow.total_pickups} pickups`
                              }
                          >
                              <Typography variant="h1" align="center">
                                  {statsPeriodNow &&
                    statsPeriodNow.total_services +
                      statsPeriodNow.total_pickups}
                              </Typography>
                          </Tooltip>
                          <Typography align="center">Total optimized services</Typography>
                      </Grid>
                  </Grid>
                  <Grid item md={2} />
                  <Grid item>
                      <Grid container direction="column">
                          <Typography variant="h6" align="center">
                Last billing period
                          </Typography>
                          <div style={{ width: '100%', height: '2px' }} />
                          <Typography align="center">{`${
                              monthNames[(new Date().getMonth() - 1) % 12]
                          } ${new Date().getFullYear()}`}</Typography>
                          <Tooltip
                              placement="right"
                              title={
                                  statsPeriodBefore &&
                  `${statsPeriodBefore.total_services} services + ${statsPeriodBefore.total_pickups} pickups`
                              }
                          >
                              <Typography variant="h1" align="center">
                                  {statsPeriodBefore &&
                    statsPeriodBefore.total_services +
                      statsPeriodBefore.total_pickups}
                              </Typography>
                          </Tooltip>
                          <Typography align="center">Total optimized services</Typography>
                      </Grid>
                  </Grid>
              </Grid>
          </Fragment>
      );
  }
}

export default withStyles(styles)(UsageBillingPeriod);
